// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__3dAKP","spinner":"Spinner_spinner__2ZZ9h","spin":"Spinner_spin__3lk0X"};